import { useState, useCallback, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navigation.css';

export default function Navigation({ darkModeChange, darkMode }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const onMenuClick = useCallback(() => {
        setMenuOpen(prev => !prev);
    }, []);

    const closeMenu = useCallback(() => {
        setMenuOpen(false);
    }, []);

    useEffect(() => {
        closeMenu();
    }, [location.pathname, closeMenu]);

    return (
        <div>
            <div className="navigation-header">
                <div className="navigation-header-left">
                    <div className="icon" onClick={onMenuClick} role="button" tabIndex={0} aria-label="Toggle menu">
                        <i className={`fa ${menuOpen ? "fa-times" : "fa-bars"}`}></i>
                    </div>
                </div>
                <div className="navigation-header-center">
                    <h1>Tri-Connect</h1>
                </div>
                <div className="navigation-header-right">
                    <div className="icon" onClick={darkModeChange} role="button" tabIndex={0} aria-label="Toggle dark mode">
                        <i className={`fa ${darkMode ? "fa-sun-o" : "fa-moon-o"}`} aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div className={`menu-overlay ${menuOpen ? "menu-open" : ""}`} onClick={closeMenu}></div>
            <nav className={`links ${darkMode ? "dark-background" : "light-background"} ${menuOpen ? "menu-open" : ""}`} id="links">
                <ul>
                    <li>
                        <Link to="/" onClick={closeMenu}>Home</Link>
                    </li>
                    <li>
                        <Link to="/game" onClick={closeMenu}>Game</Link>
                    </li>
                    <li>
                        <Link to="/about" onClick={closeMenu}>About</Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}
